import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Factory, Truck, Users, HeartHandshake } from "lucide-react";
import { LeadForm } from "@/components/site/LeadForm";

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative overflow-hidden pt-24 sm:pt-28 lg:pt-28 lg:min-h-[calc(100vw*822/1914+8rem)] flex flex-col justify-center pb-8 sm:pb-12"
    >
      {/* Fondo con imagen panorámica de una operación industrial */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/generated/op-hero-bg.jpg')" }}
        aria-hidden="true"
      />
      {/* Overlay MUY sutil para conservar la fuerza de la imagen */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-white/20" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 w-full grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-4 items-start">
        {/* CARD IZQUIERDO — texto en glass */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 rounded-3xl bg-white/85 backdrop-blur-md ring-1 ring-white/60 p-5 sm:p-6 shadow-xl shadow-brand-ink/10"
        >
          <span
            data-testid="hero-overline"
            className="inline-flex items-center gap-2 rounded-full border border-brand-yellow/50 bg-brand-yellow/15 px-3 py-1 text-[11px] sm:text-xs font-semibold uppercase tracking-widest text-brand-ink"
          >
            <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" /> Corredora certificada CMF · Chile
          </span>

          <h1
            data-testid="hero-title"
            className="font-display mt-4 text-3xl sm:text-4xl lg:text-[2.75rem] font-bold leading-[1.05] tracking-tight text-brand-ink"
          >
            Protegemos todo lo que{" "}
            <span className="text-brand-gold">mueve tu operación industrial</span>.
          </h1>

          <p className="mt-4 max-w-xl text-sm sm:text-[15px] leading-relaxed text-gray-700">
            Maquinaria, equipos, plantas, ingeniería, flotas, transporte y las personas
            que hacen funcionar tu empresa. Cotiza rápido y recibe una propuesta a medida con
            el respaldo de las principales aseguradoras del país y reaseguradores
            internacionales.
          </p>

          <div className="mt-4 grid gap-2">
            <div className="flex items-start gap-2.5 rounded-xl border border-brand-yellow/30 bg-brand-yellow/10 px-3 py-2">
              <Factory className="h-5 w-5 shrink-0 text-brand-gold mt-0.5" />
              <p className="text-sm text-gray-700">
                <span className="font-semibold text-brand-ink">Plantas, maquinaria y equipos</span>:
                incendio, avería de maquinaria y paralización de la operación.
              </p>
            </div>
            <div className="flex items-start gap-2.5 rounded-xl border border-brand-yellow/30 bg-brand-yellow/10 px-3 py-2">
              <Truck className="h-5 w-5 shrink-0 text-brand-gold mt-0.5" />
              <p className="text-sm text-gray-700">
                <span className="font-semibold text-brand-ink">Flotas, transporte y obras</span>:
                daños físicos, carga y responsabilidad civil frente a terceros.
              </p>
            </div>
            <div className="flex items-start gap-2.5 rounded-xl border border-brand-yellow/30 bg-brand-yellow/10 px-3 py-2">
              <Users className="h-5 w-5 shrink-0 text-brand-gold mt-0.5" />
              <p className="text-sm text-gray-700">
                <span className="font-semibold text-brand-ink">Colaboradores</span>: accidentes
                personales y el seguro de su auto a precio flota con{" "}
                <span className="font-semibold text-brand-ink">hasta 60% de ahorro</span>.
              </p>
            </div>
            <div
              data-testid="hero-partner-siniestro"
              className="flex items-center gap-2 rounded-xl border border-[#B9DDE4] bg-[#EAF6F8] px-2.5 py-2 sm:px-3"
            >
              <HeartHandshake className="h-4 w-4 shrink-0 text-[#00404D]" />
              <p className="whitespace-nowrap font-semibold text-[#00404D] [font-size:clamp(9.5px,2.5vw,13px)] lg:[font-size:clamp(9.5px,1.02vw,13px)]">
                Tu partner en el siniestro, te acompañamos en todo el proceso.
              </p>
            </div>
          </div>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-1.5 text-[11px] sm:text-xs font-medium text-gray-700">
            <span className="inline-flex items-center gap-1 whitespace-nowrap"><BadgeCheck className="h-3.5 w-3.5 shrink-0 text-brand-gold" /> Sin costo de cotización</span>
            <span className="inline-flex items-center gap-1 whitespace-nowrap"><BadgeCheck className="h-3.5 w-3.5 shrink-0 text-brand-gold" /> Coberturas hechas a medida</span>
          </div>
        </motion.div>

        {/* CARD DERECHO — formulario en glass (mismo estilo) */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          id="cotizar"
          className="lg:col-start-7 lg:col-span-6 w-full scroll-mt-24"
        >
          <LeadForm />
        </motion.div>
      </div>
    </section>
  );
};
